export default __webpack_public_path__ + "static/python-overview-5988d2fa6c58455058654cb11a047910.webp";